import { useTheme } from '@mui/material';
import Divider from '@mui/material/Divider';

interface Props {
  orientation?: 'horizontal' | 'vertical';
  borderStyle?: 'dashed' | 'dotted' | 'solid';
  light?: boolean;
  marginVertical?: string;
  borderWidth?: string;
}

/** A horizontal line for spacing and content separation */
export const AppDivider = ({
  orientation = 'horizontal',
  borderStyle = 'solid',
  light = true,
  marginVertical = undefined,
  borderWidth = undefined,
}: Props) => {
  const theme = useTheme();

  return (
    <Divider
      orientation={orientation}
      light={light}
      sx={{
        borderStyle,
        borderBottomWidth: borderWidth ?? '1px',
        marginTop: marginVertical ?? theme.spacing(1.5),
        marginBottom: marginVertical ?? theme.spacing(1.5),
      }}
    />
  );
};
